import React from "react";

class NightAuditPaymentsSummaryPresenter extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t("summary")}</h3>
          <div className="row container">
            <div className="col-md-12">
              <table className="table table-bordered">
                {this.renderSummaryTableHead()}
                {this.renderSummaryTableBody()}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSummaryTableHead() {
    return (
      <thead className="thead">
        <tr className="active">
          <th scope="col">{I18n.t("count")}</th>
          <th scope="col">{I18n.t("payments")}</th>
          <th scope="col">{I18n.t("refunded")}</th>
          <th scope="col">{I18n.t('total')}</th>
        </tr>
      </thead>
    );
  };

  renderSummaryTableBody() {
    return (
      <tbody>
        <tr>
          <td>{this.props.night_audit.counts.payments_count}</td>
          <td>{this.props.formatCurrency(this.props.night_audit.totals.payments)}</td>
          <td>{this.props.formatCurrency(this.props.night_audit.payments_refund_total ? this.props.night_audit.payments_refund_total : 0)}</td>
          <td>{this.props.formatCurrency(this.calculateTotal())}</td>
        </tr>
      </tbody>
    );
  };

  calculateTotal() {
    return (Object.keys(this.props.night_audit.totals).reduce((acc, key) => {
      if (key === "payments" || key === 'payments_refund_total') {
        var value = this.props.night_audit.totals[key] ? this.props.night_audit.totals[key] : 0
        acc += value
      }

      return acc
    }, 0))
  };

};

export default NightAuditPaymentsSummaryPresenter